import Immutable from 'immutable'

export const GET_SERVICES = 'takeback/api/SERVICES';
export const GET_SERVICES_SUCCESS = 'takeback/api/SERVICES_SUCCESS';
export const GET_SERVICES_FAILURE = 'takeback/api/SERVICES_FAILURE';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_SERVICES_SUCCESS:
        return state.mergeDeep(action.services.reduce((map, region) => {
            return map.set(region.get('id'), region);
        }, Immutable.Map()));
    default: return state;
    }
}

// Selectors
export function selectServices(state) {
    return state.services;
}

// Actions
export function getServices(params) {
    return { type: GET_SERVICES, params};
}

export function getServicesSuccess(services) {
    return { type: GET_SERVICES_SUCCESS, services };
}

export function getServicesFailure(error) {
    return { type: GET_SERVICES_FAILURE, error };
}
